import React from "react";
import { connect } from "react-redux";

import {
  getSchoolMessageIDList,
  getSchoolByID,
  getGoToMessageID
} from "state/teachers/selectors";
import { clearGoToMessage } from "state/teachers/actions";

import ScrollableList from "components/ScrollableList";
import List from "components/List";
import PlaceholderCard from "components/teachers/PlaceholderCard";
import Message from "components/teachers/messages/Message";
import ReplyInput from "components/teachers/messages/ReplyInput";
import LoadingThrobber from "components/LoadingThrobber";
import debounce from "debounce";

const LOAD_MESSAGE_DEBOUNCE_DELAY = 1500;

class SchoolMessageList extends React.Component {

  state = {
    messagesLimit: 15,
    initialMessages: this.props.messageIDList,
    alignToBottom: true,
    loadingMessages: false
  }

  refReplyInput = element => {
    this.props.refReplyInput(this.props.schoolID, element);
  }

  addNewMessages = debounce(() => {
    this.setState({
      loadingMessages: false,
      alignToBottom: false,
      messagesLimit: this.state.messagesLimit + 10
    });
  }, LOAD_MESSAGE_DEBOUNCE_DELAY);

  loadMoreMessages = () => {
    if(this.state.loadingMessages === true || this.state.messagesLimit >= this.state.initialMessages.size){
      return;
    }
    this.setState({loadingMessages: true});
    this.addNewMessages();
  }

  render() {

    const { messageIDList, school, schoolID, goToMessageID } = this.props;
    const { repliesEnabled } = school;
    const placeholder = <PlaceholderCard school={school} objectName="messages" />;

    const messagesCount = this.state.messagesLimit;
    const loadingMessages = this.state.loadingMessages;

    const filteredMessageIDList = messageIDList.map(function(messageID, index){
      if(index < messagesCount){
        return messageID;
      }
      return undefined;
    });

    return (
      <React.Fragment>
        <ScrollableList className="message-list" onScroll={this.props.clearGoTo} scrollTargetID={goToMessageID} alignToBottom={this.state.alignToBottom} infiniteScroll={true} loadMore={this.loadMoreMessages}>
          { refChild => (
            <List className="message-list__inner" placeholder={placeholder} reversed={true}>
              { filteredMessageIDList.map(messageID => (
                messageID !== undefined ? <Message key={messageID} messageID={messageID} innerRef={child => refChild(child, messageID)} /> : null
              )) }
              {loadingMessages ? <LoadingThrobber /> : null}
            </List>
          ) }
        </ScrollableList>
        { repliesEnabled ? <ReplyInput schoolID={schoolID} refInput={this.refReplyInput} /> : null }
      </React.Fragment>
    );

  }

}

export default connect(
  (state, { schoolID }) => ({
    messageIDList: getSchoolMessageIDList(state, schoolID),
    school: getSchoolByID(state, schoolID),
    goToMessageID: getGoToMessageID(state)
  }), {
    clearGoTo: clearGoToMessage
  }
)(SchoolMessageList);



// WEBPACK FOOTER //
// ./src/components/teachers/messages/SchoolMessageList.js